export const DEFAULT_NAME = '集团官网';

export const getBseUrl = () => {
  if (
    window.location.href?.includes('10.0.8.20') ||
    window.location.href?.includes('localhost')
  ) {
    return 'http://10.0.8.20:8080/cnzgc';
  }
  return '';
};
